// Stale-chunk recovery: after a deploy, old hashed lazy-load chunks (e.g.
// employee-data-edit.bedc8356.js) no longer exist on the server. The SPA
// fallback serves index.html with a 200, so the browser parses HTML as JS and
// throws "SyntaxError: Unexpected token '<'", or webpack/Vite throws a
// ChunkLoadError. The fix is to do a full reload so the fresh index.html points
// at the current chunk hashes.

const RELOAD_FLAG = 'sfb-chunk-reload-at'
const LOOP_WINDOW_MS = 10000

export const isStaleChunkError = (error, filename = '') => {
  const name = error?.name || ''
  const message = error?.message || (typeof error === 'string' ? error : '')

  if (name === 'ChunkLoadError') return true
  if (/Loading chunk [\w-]+ failed/i.test(message)) return true
  if (/Loading CSS chunk [\w-]+ failed/i.test(message)) return true
  if (/Failed to fetch dynamically imported module/i.test(message)) return true
  if (/error loading dynamically imported module/i.test(message)) return true
  if (/Importing a module script failed/i.test(message)) return true
  if (/'text\/html' is not a valid JavaScript MIME type/i.test(message)) return true
  // JS chunk request answered with index.html (SPA fallback) → parsed as HTML.
  // Only treat the '<' syntax error as stale-chunk when it came from a .js file.
  if (/Unexpected token '<'|expected expression, got '<'/.test(message) && /\.js(\?|$)/.test(filename)) return true

  return false
}

const recentlyReloaded = () => {
  try {
    const last = parseInt(sessionStorage.getItem(RELOAD_FLAG) || '0', 10)
    return last > 0 && Date.now() - last < LOOP_WINDOW_MS
  } catch (e) {
    return false
  }
}

const markReloaded = () => {
  try {
    sessionStorage.setItem(RELOAD_FLAG, String(Date.now()))
  } catch (e) {
    // sessionStorage unavailable (private mode / blocked) — reload anyway
  }
}

// Reload once on a stale-chunk error. Guard caps reloads to one per 10s so a
// genuinely broken build surfaces the error instead of looping forever.
export const reloadOnceForStaleChunk = (error, filename = '') => {
  if (!isStaleChunkError(error, filename)) return false
  if (recentlyReloaded()) return false
  markReloaded()
  window.location.reload()
  return true
}

export const clearStaleChunkFlag = () => {
  try {
    sessionStorage.removeItem(RELOAD_FLAG)
  } catch (e) {
    // ignore
  }
}
